export const getAllUrlParams = () => {
	const hashString = window.location.hash.replace(/^#/, '');
	const allParams = new Map<string, string>();

	// Get params from search
	const searchParams = new URLSearchParams(window.location.search);
	searchParams.forEach((value, key) => {
		allParams.set(key, value);
	});

	// Get params from hash
	if (hashString) {
		const hashParams = new URLSearchParams(hashString);
		hashParams.forEach((value, key) => {
			allParams.set(key, value);
		});
	}

	return allParams;
};
